import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, isDevMode } from '@angular/core';
import { TranslocoModule, provideTransloco } from '@jsverse/transloco';

import { LanguageCode, LanguageDefinition } from '@shure/shared/models';

import { AppLanguageListService } from './app-language-list.service';
import { TranslocoHttpLoader } from './transloco-http.loader';

@NgModule({
	exports: [TranslocoModule],
	imports: [TranslocoModule],
	providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class TranslocoRootModule {
	/**
	 * Setup application configuration for transloco.
	 */
	public static forRoot(
		languages: LanguageDefinition[],
		flatten?: boolean
	): ModuleWithProviders<TranslocoRootModule> {
		// Default language fallback
		let defaultLanguage = LanguageCode.English;
		if (!languages.some((l) => l.id === defaultLanguage)) {
			defaultLanguage = languages[0].id;
		}

		const appLanguageListService = new AppLanguageListService(languages);

		// Create Transloco module
		return {
			ngModule: TranslocoRootModule,
			providers: [
				provideTransloco({
					config: {
						defaultLang: defaultLanguage,
						fallbackLang: defaultLanguage,
						availableLangs: languages.map((l) => ({ id: l.id, label: l.name })),
						prodMode: !isDevMode(),
						reRenderOnLangChange: true,
						flatten: { aot: flatten !== undefined ? flatten : !isDevMode() },
						missingHandler: {
							logMissingKey: true,
							allowEmpty: false,
							useFallbackTranslation: true
						}
					},
					loader: TranslocoHttpLoader
				}),
				{
					provide: AppLanguageListService,
					useValue: appLanguageListService
				}
			]
		};
	}
}
